import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import HubIcon from '@mui/icons-material/Hub';
import ShowChartIcon from '@mui/icons-material/ShowChart';

/**
 * 移动端底部固定导航栏
 * 使用React Portal渲染到body，完全独立
 */
const MobileBottomNav = ({
  activeTab,
  onTabChange,
  scrollPositions,
  setScrollPositions,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const tabs = [
    { label: '设置', icon: <SettingsIcon /> },
    { label: '大纲', icon: <ListAltIcon /> },
    { label: '结构', icon: <AccountTreeIcon /> },
    { label: '章节', icon: <MenuBookIcon /> },
    { label: '关系', icon: <HubIcon /> },
    { label: '情感', icon: <ShowChartIcon /> },
  ];

  const handleTabClick = (index) => {
    const panelEl = document.getElementById(`tabpanel-${activeTab}`);
    if (panelEl) {
      const scrollBox = panelEl.querySelector('[style*="overflow-y: auto"]') || panelEl.querySelector('[class*="MuiBox-root"]');
      if (scrollBox) {
        setScrollPositions(prev => ({ ...prev, [activeTab]: scrollBox.scrollTop }));
      }
    }
    onTabChange(index);
  };

  const navContent = (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: 'linear-gradient(180deg, rgba(8, 18, 36, 0.95) 0%, rgba(5, 12, 28, 0.98) 100%)',
        backdropFilter: 'blur(24px) saturate(180%)',
        WebkitBackdropFilter: 'blur(24px) saturate(180%)',
        borderTop: '1px solid rgba(0, 229, 255, 0.12)',
        boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0, 229, 255, 0.15), inset 0 1px 0 rgba(255,255,255,0.05)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <style>{`
        @keyframes mobileNavSlideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .mobile-nav-tabs {
          display: flex !important;
          width: 100% !important;
          min-height: 55px;
        }
        .mobile-nav-tab {
          flex: 1 !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 0 !important;
          min-width: 0 !important;
          color: rgba(255,255,255,0.6) !important;
          font-size: 0.65rem !important;
          cursor: pointer;
          user-select: none;
        }
        .mobile-nav-tab.active {
          color: #00d4ff !important;
        }
        .mobile-nav-tab svg {
          font-size: 1.2rem !important;
          margin-bottom: 2px;
        }
        .mobile-nav-tab span {
          line-height: 1.2;
        }
      `}</style>
      <div 
        className="mobile-nav-tabs"
        style={{ animation: 'mobileNavSlideUp 0.45s cubic-bezier(0.22, 1, 0.36, 1)' }}
      >
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`mobile-nav-tab ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
    </div>
  );

  if (!mounted) return null;
  return ReactDOM.createPortal(navContent, document.body);
};

export default MobileBottomNav;
